import{jsx as e}from"react/jsx-runtime";import{styled as n}from"styled-components";const t="\n  min-height: 16px;\n  white-space: normal;\n  vertical-align: middle;\n",l=n.div`
  ${t}
`,i=n.label`
  ${t}
`;function r({className:n,type:t,htmlFor:r,children:c}){return"block"===t?e(l,{className:n,children:c}):e(i,{htmlFor:r,className:n,children:c})}const c=n(r)`
  line-height: 22px;
`;export{c as FieldHighLabel,r as Label};
